<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.customPostList')"
    resource="custom_post_lists"
    :actionColumnProps="{ width: 180 }"
    :before-submit="onBeforeSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/custom_post_lists.js';
import { ARTICLE_TYPE } from '@/constants';
import _ from 'lodash';

@Component
export default class CustomPostLists extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'keyword'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      'remark',
      type === 'show' && 'posts',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'title',
      'remark',
      {
        key: 'posts',
        renderCell: {
          component: 'listSelect',
          props: {
            label: 'title',
            filterColumns: [
              {
                prop: 'type_eq',
                label: '文章类型',
                renderCell: {
                  required: true,
                  component: 'select',
                  props: {
                    options: _.map(ARTICLE_TYPE, (label, value) => ({ label, value }))
                  }
                }
              },
              {
                prop: 'keyword',
                label: '文章标题',
                renderCell: {
                  component: 'input',
                  attrs: {
                    placeholder: '请输入关键字查询',
                  }
                }
              }
            ],
            onFilter: (params) => {
              return this.$request.get('/posts/read_options', { params: { ...params, page: 0 } })
            },
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  onBeforeSubmit({ data }) {
    const cplps = (data.custom_post_lists_posts || []).map(item => ({ ...item, _destroy: true }))
    _.each(data.posts || [], (post, i) => {
      const cplp = _.find(cplps, { post_id: post.id })
      if (cplp) {
        cplp._destroy = false
        cplp.position = i
      } else {
        cplps.push({ post_id: post.id, position: i })
      }
    })
    return {
      ...data,
      custom_post_lists_posts_attributes: cplps
    };
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'custom_post_lists.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'custom_post_lists.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/custom_post_lists',
    name: 'custom_post_lists.index',
    component: CustomPostLists,
    props: {
      type: 'index',
    }
  },
  {
    path: '/custom_post_lists/new',
    name: 'custom_post_lists.new',
    component: CustomPostLists,
    props: {
      type: 'new',
    }
  },
  {
    path: '/custom_post_lists/:id',
    name: 'custom_post_lists.show',
    component: CustomPostLists,
    props: {
      type: 'show',
    }
  },
  {
    path: '/custom_post_lists/:id/edit',
    name: 'custom_post_lists.edit',
    component: CustomPostLists,
    props: {
      type: 'edit'
    }
  }
]
</script>
